export const ASSETS_URL = "https://raw.githubusercontent.com/UCL/";
